import { BasicToolboxProps, Toolbox } from "../../toolbox";
import { ThumbnailGrid } from "../../toolbox-components/toolbox-component-thumbnail-grid";
import styles from "../..//toolbox.module.css";
import { usePosterProject } from "PosterEditor/model/poster-project-provider";

interface ToolboxMapStyleProps extends BasicToolboxProps {}
export const ToolboxMapStyle = (props: ToolboxMapStyleProps) => {
  const { project, mapStyles, setMapStyle } = usePosterProject();

  return (
    <Toolbox
      title="Map Style"
      collapsible={props.collapsible}
      isCollapsed={props.isCollapsed}
      onToggleCollapse={props.onToggleCollapse}
    >
      <div
        className={styles.paddedBodyContent}
        key={mapStyles.length > 0 ? "collapsedMapStyle" : "expandedMapStyle"}
      >
        {mapStyles.length > 0 && (
          <ThumbnailGrid
            thumbnails={mapStyles}
            selectedThumbnailId={project.mapStyle}
            onSelectThumbnail={(thumbnailID) => {
              setMapStyle(thumbnailID);
            }}
          />
        )}
      </div>
    </Toolbox>
  );
};
